export type { AppNotification, FulfillmentAppNotification, GeneralAppNotification, GlobalAppNotification, JobAppNotification, NotificationStatus } from 'context/NotificationCenterContext';

export const NOTIFICATION_VARIANT = {
  STARTED:    'started',
  PROCESSING: 'processing',
  COMPLETED:  'completed',
  FAILED:     'failed',
  GLOBAL:     'global',
  GENERAL:    'general',
} as const;

export type NotificationVariant = typeof NOTIFICATION_VARIANT[keyof typeof NOTIFICATION_VARIANT];
